import { Grid, makeStyles, Tab, Tabs } from "@material-ui/core";
import { PageHeader } from "components/UI/Page";
import TabPanel from "components/UI/Tabs/TabPanel";
import { observer } from "mobx-react-lite";
import { lang } from "../../i18nLang";
import {
  AccessProfileStore,
  CompanyStore,
  MessageStore,
  ProfileStore,
} from "../../store/index";
import AccessProfiles from "./AccessProfiles";
import CompanyForm from "./Company";
import Employees from "./Employees";
import MyProfile from "./MyProfile";

const useStyles = makeStyles({ tabsContent: { height: "100%", flexGrow: 2 } });

const Profile = observer(() => {
  const classes = useStyles();
  const { currentTab } = ProfileStore;
  const { currentCompany } = CompanyStore;

  const handleChange = (event, newValue: number) => {
    if (
      (newValue === 1 || newValue === 2) &&
      !AccessProfileStore.currentUserIsAdmin()
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }
    ProfileStore.setCurrentTab(newValue);
  };

  return (
    <>
      <PageHeader>
        <Tabs
          value={currentTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          className={classes.tabsContent}
        >
          <Tab label={lang("userProfile.myProfile")} />
          <Tab label={lang("userProfile.enterprise")} />
          <Tab label={lang("userProfile.collaborators")} />
          {AccessProfileStore.currentUserIsAdmin() && (
            <Tab label={lang("userProfile.accessProfile")} />
          )}
        </Tabs>
      </PageHeader>
      <Grid container item xs>
        <TabPanel value={currentTab} index={0}>
          <MyProfile />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <CompanyForm company={currentCompany} />
        </TabPanel>
        <TabPanel value={currentTab} index={2}>
          <Employees />
        </TabPanel>
        <TabPanel value={currentTab} index={3}>
          <AccessProfiles />
        </TabPanel>
      </Grid>
    </>
  );
});

export default Profile;
